import { useContext, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { DashboardContext } from '../../../contexts/states/DashboardState';
import { formattedMonth } from '../../../contexts/utils';
import { StatsListCon } from '../../Layouts/dashboard layouts/StatsListCon';
import { GlobalLoading } from '../../Layouts/GlobalLoading';

export const UsersPage = () => {
  const { users, initLoading } = useContext(DashboardContext);
  const [monthUsers, setMonthUsers] = useState([]);

  useEffect(() => {
    const monthIndex = new Date().getMonth();

    if (users.length >= 1) {
      const monthUsers = [];
      users.forEach((user) => {
        if (user.month - 1 === monthIndex) {
          monthUsers.push(user);
        }
      });
      setMonthUsers(monthUsers);
    }
  }, [users]);

  return (
    <div className='main list'>
      <Helmet>
        <title>All Users | LionTaxi Admin</title>
      </Helmet>
      {initLoading && (
        <div className='background-overlay active'>
          <GlobalLoading />
        </div>
      )}
      <header className='desktop'>
        <h2>Users</h2>
      </header>
      <div className='cards list'>
        <div className='cards-info'>
          <div>
            <p>All Users</p>
            <p>{users.length}</p>
          </div>
          <div>
            <p>{formattedMonth} Users</p>
            <p>{monthUsers.length}</p>
          </div>
        </div>
      </div>
      <div className='stats-list'>
        <div className='stats-list-header'>
          <p>Username</p>
          <p>Completed Rides</p>
          <p>Canceled Rides</p>
          <p>Date Joined</p>
        </div>
        <div className='stats-list-body'>
          {users.map((user) => (
            <StatsListCon user={user} key={user.id} ride={false} />
          ))}
        </div>
      </div>
    </div>
  );
};
